import Vue from "Vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userinfo: {}
  },
  mutations: {
    SET_USER_INFO(state, userinfo) {
      state.userinfo = userinfo;
    }
  },
  actions: {
    setUserInfo({
      commit
    }, userinfo) {
      commit("SET_USER_INFO", userinfo);
    }
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js